import React from "react";
import AlvComponentModel from 'components/Models/AlvComponent/AlvComponent';
import PropTypes from 'prop-types';
import "./AlvStockExchangeAnnouncement.scss";

const AlvStockExchangeAnnouncement = ({ language, paginated, pageSize }) => {
    return (
        <div className="alv-stock-exchange-announcement">
            <investor-stock-exchange-announcement 
                lang={language} 
                compact="compact"
                {...(paginated && {
                    paginated
                })}
                pageSize={pageSize}
            ></investor-stock-exchange-announcement>
        </div>
    );
};

AlvStockExchangeAnnouncement.propTypes = Object.assign({}, AlvComponentModel.propTypes, {
    paginated: PropTypes.bool,
    pageSize: PropTypes.number
});

export default AlvStockExchangeAnnouncement;


// WEBPACK FOOTER //
// ./src/components/AlvStockExchangeAnnouncement/AlvStockExchangeAnnouncement.jsx